import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingPromoCarouselContainer } from './parts/NewbuildingPromoCarouselContainer';
import { ShowAllNewbuildingsLinkContainer } from './parts/ShowAllNewbuildingsLinkContainer';
import { trackNewbuildingCarouselShow } from './tracking';
import { NewbuildingsFromDeveloper } from '../../components/NewbuildingsFromDeveloper';
import { selectOfferId } from '../../selectors';
import { selectNewbuildingFromDeveloperIds } from '../../selectors/newObject';

// ts-unused-exports:disable-next-line
export const NewbuildingsFromDeveloperContainer: React.FC = () => {
  const newbuildingIds = useSelector(selectNewbuildingFromDeveloperIds);
  const offerId = useSelector(selectOfferId);

  const handleCarouselShow = React.useCallback(() => {
    trackNewbuildingCarouselShow({ newbuildingIds, offerId });
  }, [newbuildingIds, offerId]);

  return (
    <ActionAfterViewObserver callback={handleCarouselShow} wrapper={false} triggerOnce>
      <NewbuildingsFromDeveloper showAllLink={<ShowAllNewbuildingsLinkContainer />}>
        <NewbuildingPromoCarouselContainer />
      </NewbuildingsFromDeveloper>
    </ActionAfterViewObserver>
  );
};
